import './radio_checkbox.scss';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '..';
const RadioCheckbox = _ref => {
  let {
    checked,
    className,
    disabled,
    name,
    value,
    onChange,
    onClick,
    rounded,
    type,
    text,
    label,
    labelActive,
    propagationStop,
    partlyChecked,
    defaultTheme
  } = _ref;
  const {
    theme
  } = useTheme();
  const componentTheme = defaultTheme || theme;
  const handleChange = e => {
    if (disabled) return;
    if (propagationStop) e.stopPropagation();
    const inputChecked = e.target.checked;
    onChange(inputChecked, name, value);
  };
  const handleClick = e => {
    if (propagationStop && e) e.stopPropagation();
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/React.createElement("label", {
    className: classNames(`wrts-${type}`, className, componentTheme, {
      disabled,
      rounded,
      'partly-checked': partlyChecked
    }),
    onClick: propagationStop ? e => e.stopPropagation() : undefined
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    disabled: disabled,
    name: name,
    value: value,
    onChange: handleChange,
    onClick: handleClick,
    type: type
  }), /*#__PURE__*/React.createElement("span", {
    className: "visual"
  }), text.length && /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, text), label && /*#__PURE__*/React.createElement("span", {
    className: classNames('label', {
      active: labelActive
    })
  }, label));
};
RadioCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  name: 'checkbox',
  onChange: () => {},
  rounded: false,
  type: 'checkbox',
  text: '',
  propagationStop: false,
  partlyChecked: false
};
RadioCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  text: PropTypes.string,
  label: PropTypes.string,
  labelActive: PropTypes.bool,
  propagationStop: PropTypes.bool,
  partlyChecked: PropTypes.bool,
  defaultTheme: PropTypes.string
};
export default /*#__PURE__*/memo(RadioCheckbox);